import React, { useContext } from 'react';
import { Layout } from 'antd';
import { Route, Switch, withRouter } from 'react-router-dom';

import { UserAccessContext } from 'context/userAccess';
import Login from 'modules/login';
import ChangePassword from 'modules/change_password';
import DashboardPage from 'modules/main/dashboard';
import CreateRequestPage from 'modules/main/lab_request/create';
import EditRequestPage from 'modules/main/lab_request/edit';
import ViewRequestPage from 'modules/main/lab_request/view';
import EditLabResult from 'modules/main/lab_result/search_result_for_edit';
import PrintLabResult from 'modules/main/lab_result/search_result_for_print';
import PatientInfo from 'modules/main/lab_result/edit_result';
import PhleboSearch from 'modules/main/phlebo';
import Iresults from 'modules/main/iresults';
import PhleboPatientResult from 'modules/main/phlebo/patient_phlebo_info';
import ErrorPage from 'modules/error_page';
import SearchPatient from 'modules/main/patient_demographics';
import Settings from 'modules/main/settings';
import Inventory from 'modules/inventory';
import BloodBank from 'modules/blood_bank';
import Cashier from 'modules/main/cashier';
import Checkin from 'modules/main/checkin';
import Receipt from 'modules/main/cashier/receipt';
import Transactions from 'modules/main/cashier/transactions';
import Categories from 'modules/main/cashier/categories';
import Summary from 'modules/main/cashier/summary';
import PrivateRoute from 'shared_components/private_route';
import Boilerplate from 'modules/boilerplate';
import DataAnalysis from 'modules/main/data_analysis';

const { Content: Antcontent } = Layout;
const wrapperStyle = {
	minHeight: 280,
	background: 'white',
	//   width: '100%',
	padding: 24,
};

function Content() {
	const { userAccess } = useContext(UserAccessContext);

	return (
		<Antcontent style={wrapperStyle}>
			<Switch>
				<Route exact path="/" component={DashboardPage} />
				<Route path="/login" component={Login} />
				<Route path="/change-password" component={ChangePassword} />
				<Route path="/dashboard" component={DashboardPage} />
				<PrivateRoute
					path="/request/create"
					component={userAccess.createRequest.view ? CreateRequestPage : ErrorPage}
				/>
				<PrivateRoute
					path="/request/edit"
					component={userAccess.editRequest.view ? EditRequestPage : ErrorPage}
				/>
				<PrivateRoute
					path="/request/view"
					component={userAccess.viewRequest.view ? ViewRequestPage : ErrorPage}
				/>
				<PrivateRoute
					path="/lab/result/edit"
					component={userAccess.result.view ? EditLabResult : ErrorPage}
				/>
				<PrivateRoute
					path="/lab/result/print"
					component={userAccess.result.view ? PrintLabResult : ErrorPage}
				/>
				<PrivateRoute
					path="/patientinfo"
					component={userAccess.result.view ? PatientInfo : ErrorPage}
				/>
				<PrivateRoute path="/iresults" component={Iresults} />
				<PrivateRoute
					path="/phlebo/result"
					component={userAccess.plhebo.view ? PhleboSearch : ErrorPage}
				/>
				<PrivateRoute
					path="/phlebo/patient"
					component={userAccess.plhebo.view ? PhleboPatientResult : ErrorPage}
				/>
				<PrivateRoute
					path="/patient/search"
					component={userAccess.patientDemographics.view ? SearchPatient : ErrorPage}
				/>
				<PrivateRoute
					path="/settings"
					component={userAccess.settings.view ? Settings : ErrorPage}
				/>
				<PrivateRoute
					path="/data-analysis"
					component={userAccess.dataAnalysis.view ? DataAnalysis : ErrorPage}
				/>
				<PrivateRoute
					path="/inventory"
					component={Inventory}
				/>
				<PrivateRoute path="/bloodbank" component={userAccess.settings.view ? BloodBank : ErrorPage} />
				<PrivateRoute path="/boilerplate" component={Boilerplate} />
				<Route exact path="/cashier" component={Cashier} />
				<PrivateRoute
					path="/checkin"
					component={userAccess.checkIn.view ? Checkin : ErrorPage}
				/>
				<Route path="/cashier/receipt" component={Receipt} />
				<Route path="/cashier/transactions" component={Transactions} />
				<Route path="/cashier/categories" component={Categories} />
				<Route path="/cashier/summary" component={Summary} />
				<Route component={ErrorPage} />
			</Switch>
		</Antcontent>
	);
}

export default withRouter(Content);
